module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBold.0fbcc9e.woff";